import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, Typography, useEventCallback } from '@mui/material';
import { memo, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { FormikErrors, FormikTouched, useFormikContext } from 'formik';
import VoidMarriageForm from './form';
import {
  NewPersonVM,
  AccordionVoidMarriage,
} from 'shell/components/shared/sipo-person-form/new-person';

const VoidMarriageComponent = (): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(false);

  const formContext = useFormikContext<NewPersonVM>();

  const onFieldVoidMarriageChange = useEventCallback(
    (
      key: keyof AccordionVoidMarriage,
      value: AccordionVoidMarriage[keyof AccordionVoidMarriage]
    ) => {
      formContext.setFieldValue('voidMarriage', {
        ...formContext.values.voidMarriage,
        [key]: value,
      });
    }
  );

  const onFieldsMarriageChange = useEventCallback((values: AccordionVoidMarriage) => {
    formContext.setFieldValue('voidMarriage', {
      ...formContext.values.voidMarriage,
      ...values,
    });
  });

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-person-void-marriage-content"
        id="panel-person-void-marriage-header"
        expandIcon={<ExpandMore />}
      >
        <Typography>
          Cessazione Matrimonio
          {formContext?.errors?.voidMarriage && formContext?.touched?.voidMarriage ? (
            <Typography style={{ color: '#d6012e', display: 'inline', paddingLeft: '10px' }}>
              Attenzione verificare dati errati o mancanti
            </Typography>
          ) : undefined}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <VoidMarriageForm
          values={formContext.values.voidMarriage}
          onChange={onFieldVoidMarriageChange}
          onFieldsChange={onFieldsMarriageChange}
          errors={formContext.errors.voidMarriage as FormikErrors<AccordionVoidMarriage>}
          touched={
            formContext.touched.voidMarriage as unknown as FormikTouched<AccordionVoidMarriage>
          }
        />
      </AccordionDetails>
    </Accordion>
  );
};

VoidMarriageComponent.displayName = 'Accordion void marriage component';

const VoidMarriage = memo(VoidMarriageComponent);

export default VoidMarriage;
